import _ from "underscore";

import { CanvasHandler } from "../../handlers";
import { FabricEvent, FabricObject } from "../../types/FabricCustomType";
import { IObjectSelector } from "../../types/HandlerObjectType";

class PolygonZone implements IObjectSelector {
  private canvasHandler: CanvasHandler;
  private targetSeat: FabricObject;

  constructor(canvasHandler: CanvasHandler) {
    this.canvasHandler = canvasHandler;
  }
  activateObjectHover(event: FabricEvent<MouseEvent | TouchEvent>) {
    throw new Error("Method not implemented.");
  }
  deactivateObjectHover() {
    throw new Error("Method not implemented.");
  }
  handleSelectObject(event: FabricEvent<MouseEvent | TouchEvent>) {
    throw new Error("Method not implemented.");
  }
  handleObjectLockUpdate(valueHub: any) {
    throw new Error("Method not implemented.");
  }

  public onMouseDblClick(event: FabricEvent<Event>) {

  }

  public onHover(event: any): any {
  }

  public async onSelect(event: any) {
    const {target} = event;
    const shape = target.item(0);
    const text = target.item(1);
    shape.set({visible: false});
    text.set({visible: false});
    this.canvasHandler.activeZoneSelector = target;
    this.canvasHandler.zoomHandler.zoomToCenterWithObject(target);
  }

  public async onChangeHub(valueHub: any): Promise<any> {
    }
}

export default PolygonZone;
